import { MotionValue, useMotionValueEvent } from "framer-motion";
import { memo, useState } from "react";

import { Slider } from "@/components/ui/slider";
import { Typography } from "@/components/ui/typography";

interface BrushControlPlaybackSpeedSliderProps {
  cursorPlaybackSpeedMotionValue: MotionValue<number>;
  onPlaybackSpeedChange: (speed: number) => void;
  isLive: boolean;
}

const BrushControlPlaybackSpeedSlider = memo(
  function BrushControlPlaybackSpeedSlider({
    cursorPlaybackSpeedMotionValue,
    onPlaybackSpeedChange,
    isLive,
  }: BrushControlPlaybackSpeedSliderProps) {
    const [playbackSpeed, setPlaybackSpeed] = useState(
      cursorPlaybackSpeedMotionValue.get(),
    );

    useMotionValueEvent(cursorPlaybackSpeedMotionValue, "change", (latest) => {
      setPlaybackSpeed(latest);
    });

    return (
      <div
        // width: "stretch",
        // height: "48px",
        className="flex items-center justify-center gap-2"
      >
        <Typography level="body-sm" className="min-w-fit">
          Speed:
        </Typography>
        <Slider
          disabled={isLive}
          value={[Math.log10(playbackSpeed)]}
          onValueChange={([value]) => {
            const newSpeed = Math.pow(10, value);
            onPlaybackSpeedChange(newSpeed);
          }}
          min={Math.log10(0.01)} // 0.01x
          max={Math.log10(100)} // 100x
          step={0.01}
          className="w-50"
        />
        <Typography level="body-sm" className="min-w-fit font-mono">
          {playbackSpeed.toFixed(2)}x
        </Typography>
      </div>
    );
  },
);

export { BrushControlPlaybackSpeedSlider };
